module.exports = __webpack_public_path__ + "img/cute.a45431b8.png";